import Portal from '@mui/material/Portal';

import { _Lucide } from '../../../../ui/lucide'
import { Info, AlertTriangle, AlertOctagon, CheckIcon } from 'lucide-react';

import { SnackbarRoot } from './styles';
import { snackbarClasses } from './classes';

// ----------------------------------------------------------------------

export function Snackbar() {
  return (
    <Portal>
      <SnackbarRoot
        expand
        gap={12}
        closeButton
        offset={16}
        visibleToasts={4}
        position="top-right"
        className={snackbarClasses.root}
        toastOptions={{
          unstyled: true,
          classNames: {
            toast: snackbarClasses.toast,
            icon: snackbarClasses.icon,
            // content
            content: snackbarClasses.content,
            title: snackbarClasses.title,
            description: snackbarClasses.description,
            // button
            actionButton: snackbarClasses.actionButton,
            cancelButton: snackbarClasses.cancelButton,
            closeButton: snackbarClasses.closeButton,
            // state
            default: snackbarClasses.default,
            info: snackbarClasses.info,
            error: snackbarClasses.error,
            success: snackbarClasses.success,
            warning: snackbarClasses.warning,
          },
        }}
        icons={{
          loading: <span className={snackbarClasses.loadingIcon} />,
          info: <_Lucide className={snackbarClasses.iconSvg} icon={Info} />,
          success: <_Lucide className={snackbarClasses.iconSvg} icon={CheckIcon} />,
          warning: <_Lucide className={snackbarClasses.iconSvg} icon={AlertTriangle} />,
          error: <_Lucide className={snackbarClasses.iconSvg} icon={AlertOctagon} />,
        }}
      />
    </Portal>
  );
}
